import React from 'react';
import { useTranslation } from 'react-i18next';
import '../YesNoButtons/YesNoButtons.css';

export type ConsentTriValue = 'Yes' | 'No' | null;

interface ConsentTriYesNoProps {
  value: ConsentTriValue;
  onChange: (value: ConsentTriValue) => void;
}

/**
 * Yes / No / none (pending) for parental consent — none shows neither button as active.
 */
const ConsentTriYesNo: React.FC<ConsentTriYesNoProps> = ({ value, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="yes-no-group consent-tri-yes-no" role="radiogroup" aria-label={t('consents.choiceLabel')}>
      <button
        type="button"
        role="radio"
        className={`yes-no-button ${value === 'Yes' ? 'active' : ''}`}
        onClick={() => onChange(value === 'Yes' ? null : 'Yes')}
        aria-checked={value === 'Yes'}
      >
        {t('form.answersSection.yes')}
      </button>
      <button
        type="button"
        role="radio"
        className={`yes-no-button ${value === 'No' ? 'active' : ''}`}
        onClick={() => onChange(value === 'No' ? null : 'No')}
        aria-checked={value === 'No'}
      >
        {t('form.answersSection.no')}
      </button>
    </div>
  );
};

export default ConsentTriYesNo;
